/***
 *
 *   EMPTY STATE STYLES
 *   Ported from ui-reference/src/components/ui/empty-state.tsx.
 *
 **********/

const Style = {
    base: 'flex min-h-[180px] flex-col items-center justify-center rounded-lg border border-dashed border-border bg-surface p-6 text-center',
    iconWell: 'mb-3 rounded-full bg-primary-50 p-3 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300',
    title: 'text-base font-semibold text-text-primary',
    text: 'mt-1 max-w-md text-sm text-text-secondary',
    action: 'mt-4',

    // The reference drops the frame when the empty state fills a region that
    // already has one (an empty kanban board, a table body).
    bare: 'border-none bg-transparent',
};

export default Style;
